export default class LuSelectItem {
	data: any;

	constructor() {}
}
